import loadable from "@loadable/component"
import TextBlockWithImage from "./TextBlockWithImage"
import Heading from "./Heading"
import FeaturedPost from "./FeaturedPost"
import PostsListing from "./PostsListing"
import PostDetails from "./PostDetails"
import RichTextArea from "./RichTextArea"
import ListingSearch from "./ListingSearch"
import PeopleSearch from "./PeopleSearch"
import ListingCarousel from "./ListingCarousel"
import LineSeparator from "./LineSeparator"
import VineyardGazetteCalendar from "./VineyardGazetteCalendar"
import ContactForm from "./ContactForm"
import CommunityList from "./CommunityList"
import RentalSearch from "./RentalSearch"
import RentalIncludeMlsSearch from "./RentalIncludeMlsSearch"
import MarketStats from "./MarketStats"
import ListingEntrySearch from "./ListingEntrySearch"
import RentalEntrySearch from "./RentalEntrySearch"
import DividedBladeContentLong from "./DividedBladeContentLong"
import DividedBladeContentShort from "./DividedBladeContentShort"
import SideBySideLayoutBlade from "./SideBySideLayoutSection"
import ThreeColumnCards from "./ThreeColumnCards"
import FeaturedAffiliatedAgent from "./FeaturedAffiliatedAgent"
import TextBlockWithBackgroundImage from "./TextBlockWithBackgroundImage"
import SellForm from "./SellForm"
import PublicationsListing from "./PublicationsListing"
import PartnersListing from "./PartnersListing"
import TabbedFeaturedContent from "./TabbedFeaturedContent"
import TextBlockWithEmbed from "./TextBlockWithEmbed"
import TwoColumnTextLayout from "./TwoColumnTextLayout"
import ManualStats from "./ManualStats"
import JuicerFeed from "./JuicerFeed"
import CommunitiesContentWithTabs from "./CommunitiesContentWithTabs"
import LocationAutocompleteSearch from "./LocationAutocompleteSearch"
import DevelopmentsListing from "./DevelopmentsListing"
import BuildersSearch from "./BuildersSearch"
import TextBlockWithBackgroundVideo from "./TextBlockWithBackgroundVideo"
import OfficesCarousel from "./OfficesCarousel"
import NewestBlogPosts from "./NewestBlogPosts"
import OfficesSearch from "./OfficesSearch"
import FilteredListingsSearch from "./FilteredListingsSearch"
import BiographyBlade from "./BiographyBlade"
import ListingSearchCompact from "./ListingSearchCompact"
import PartnersMapSearch from "./PartnersMapSearch"
import ImagesCardsCarousel from "./ImagesCardsCarousel"
import ImageWithOverlappingText from "./ImageWithOverlappingText"
import InfoBoxWithGrid from "./InfoBoxWithGrid"
import LocationMap from "./LocationMap"
import OfficesGrid from "./OfficesGrid"
import OffMarketListingsSearch from "./OffMarketListingsSearch"
import FeaturedContentSlider from "./FeaturedContentSlider"
import ListingsTabs from "./ListingsTabs"
import OfficesByCity from "./OfficesByCity"
import VideosListing from "./VideosListing"
import TextVideoPair from "./TextVideoPair"
import ImagesCarousel from "./ImagesCarousel"
import VirtualTours from "./VirtualTours"
import NAILandmarkAgentsAndListings from "./NAILandmarkAgentsAndListings"
import FeaturedAgent from "./FeaturedAgent"
import AllPropertiesCarousel from "./AllPropertiesCarousel"
import TestimonialList from "./TestimonialList"
import NewestListings from "./NewestListings"
import ContactDetailsSection from "./ContactDetailsSection"
import MarketStatsWithSlider from "./MarketStatsWithSlider"
import TestimonialSlider from "./TestimonialSlider"

// All of the Agility Page Module Components that are in use in this site need to be imported into this index file.
// Place Page Modules in allModules array below, passing in a name and the component.

const allModules = [
  { name: "TextBlockWithImage", module: TextBlockWithImage },
  { name: "Heading", module: Heading },
  { name: "FeaturedPost", module: FeaturedPost },
  { name: "PostsListing", module: PostsListing },
  { name: "PostDetails", module: PostDetails },
  { name: "RichTextArea", module: RichTextArea },
  { name: "ListingSearch", module: ListingSearch },
  { name: "PeopleSearch", module: PeopleSearch },
  { name: "ListingCarousel", module: ListingCarousel },
  { name: "LineSeparator", module: LineSeparator },
  { name: "VineyardGazetteCalendar", module: VineyardGazetteCalendar },
  { name: "ContactForm", module: ContactForm },
  { name: "CommunityList", module: CommunityList },
  { name: "RentalSearch", module: RentalSearch },
  { name: "RentalIncludeMlsSearch", module: RentalIncludeMlsSearch },
  { name: "MarketStats", module: MarketStats },
  { name: "ListingEntrySearch", module: ListingEntrySearch },
  { name: "RentalEntrySearch", module: RentalEntrySearch },
  { name: "DividedBladeContentLong", module: DividedBladeContentLong },
  { name: "DividedBladeContentShort", module: DividedBladeContentShort },
  { name: "SideBySideLayoutBlade", module: SideBySideLayoutBlade },
  { name: "ThreeColumnCards", module: ThreeColumnCards },
  { name: "FeaturedAffiliatedAgent", module: FeaturedAffiliatedAgent },
  {
    name: "TextBlockWithBackgroundImage",
    module: TextBlockWithBackgroundImage,
  },
  { name: "SellForm", module: SellForm },
  { name: "PublicationsListing", module: PublicationsListing },
  { name: "PartnersListing", module: PartnersListing },
  { name: "TabbedFeaturedContent", module: TabbedFeaturedContent },
  { name: "TextBlockWithEmbed", module: TextBlockWithEmbed },
  { name: "TwoColumnTextLayout", module: TwoColumnTextLayout },
  { name: "ManualStats", module: ManualStats },
  { name: "JuicerFeed", module: JuicerFeed },
  { name: "CommunitiesContentWithTabs", module: CommunitiesContentWithTabs },
  { name: "LocationAutocompleteSearch", module: LocationAutocompleteSearch },
  { name: "DevelopmentsListing", module: DevelopmentsListing },
  { name: "BuildersSearch", module: BuildersSearch },
  {
    name: "TextBlockWithBackgroundVideo",
    module: TextBlockWithBackgroundVideo,
  },
  { name: "OfficesCarousel", module: OfficesCarousel },
  { name: "NewestBlogPosts", module: NewestBlogPosts },
  { name: "OfficesSearch", module: OfficesSearch },
  { name: "FilteredListingsSearch", module: FilteredListingsSearch },
  { name: "BiographyBlade", module: BiographyBlade },
  { name: "ListingSearchCompact", module: ListingSearchCompact },
  { name: "PartnersMapSearch", module: PartnersMapSearch },
  { name: "ImagesCardsCarousel", module: ImagesCardsCarousel },
  { name: "ImageWithOverlappingText", module: ImageWithOverlappingText },
  { name: "InfoBoxWithGrid", module: InfoBoxWithGrid },
  { name: "LocationMap", module: LocationMap },
  { name: "OfficesGrid", module: OfficesGrid },
  { name: "OffMarketListingsSearch", module: OffMarketListingsSearch },
  { name: "FeaturedContentSlider", module: FeaturedContentSlider },
  { name: "ListingsTabs", module: ListingsTabs },
  { name: "OfficesByCity", module: OfficesByCity },
  { name: "VideosListing", module: VideosListing },
  { name: "TextVideoPair", module: TextVideoPair },
  { name: "ImagesCarousel", module: ImagesCarousel },
  { name: "VirtualTours", module: VirtualTours },
  {
    name: "NAILandmarkAgentsAndListings",
    module: NAILandmarkAgentsAndListings,
  },
  { name: "FeaturedAgent", module: FeaturedAgent },
  { name: "AllPropertiesCarousel", module: AllPropertiesCarousel },
  { name: "TestimonialList", module: TestimonialList },
  { name: "NewestListings", module: NewestListings },
  { name: "ContactDetailsSection", module: ContactDetailsSection },
  { name: "MarketStatsWithSlider", module: MarketStatsWithSlider },
  { name: "TestimonialSlider", module: TestimonialSlider },
]

export const getModule = moduleName => {
  if (!moduleName) return null
  const obj = allModules.find(
    m => m.name.toLowerCase() === moduleName.toLowerCase()
  )
  if (!obj) return null
  if (typeof obj.module === "string") {
    return loadable(() => import(`./${obj.module}`))
  } else {
    return obj.module
  }

  //return module
}
